import { FC } from 'react';
import { WbCard, WbCardContent } from '@agilelab/plugin-wb-platform';
import { Editor } from '../common/Editor/Editor';

interface PolicyCueScriptEditorProps {
  onUpdate?: (code?: string) => void;
  editable?: boolean;
  cueScript: string;
  saving?: boolean;
  handleSave?: () => void;
  showSaveButton?: boolean;
}

export const PolicyCueScriptEditor: FC<PolicyCueScriptEditorProps> = props => {
  return (
    <WbCard title="Cue script">
      <WbCardContent>
        <Editor
          theme={props.editable ? 'white' : 'default'}
          id="policy-editor"
          content={props.cueScript}
          onUpdate={props.onUpdate}
          editable={props.editable}
          saving={props.saving}
          handleSave={props.handleSave}
          showSaveButton={props.showSaveButton}
          parser="go"
        />
      </WbCardContent>
    </WbCard>
  );
};
